module.exports = {"TXTWCL_Login_to_bet":{"id":"TXTWCL_Login_to_bet","defaultMessage":"Connectez-vous pour parier","track":"Login to Bet"}}